var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fas",class:{
        'fa-flag text-warning': _vm.flag == 'orange',
        'fa-flag text-danger': _vm.flag == 'red'
    }})}
var staticRenderFns = []

export { render, staticRenderFns }